import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 4px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  line-height: 1.5;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from '../link/Link';
var ItemWrapper = styled.span(_templateObject(), themeGet('breadcrumb.text.fontSize'), themeGet('breadcrumb.text.color'));
var BreadcrumbLink = styled(Link)(_templateObject2(), themeGet('breadcrumb.link.fontSize'), themeGet('breadcrumb.link.color'), themeGet('breadcrumb.link.hover.color'), themeGet('breadcrumb.link.active.color'));
var Text = styled.span(_templateObject3(), themeGet('breadcrumb.text.current.color'));
var Separator = styled.span(_templateObject4());

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? '/' : _ref$separator,
      href = _ref.href,
      current = _ref.current,
      linkProps = _ref.linkProps,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["separator", "href", "current", "linkProps", "children"]);

  var link = null;

  if (current) {
    link =
    /*#__PURE__*/
    React.createElement(Text, null, children);
  } else {
    link =
    /*#__PURE__*/
    React.createElement(BreadcrumbLink, _extends({
      target: "_self",
      href: href
    }, linkProps), children);
  }

  return (
    /*#__PURE__*/
    React.createElement(ItemWrapper, rest, link, !current &&
    /*#__PURE__*/
    React.createElement(Separator, null, separator))
  );
};

var Wrapper = styled.div(_templateObject5());
export var Breadcrumb = function Breadcrumb(_ref2) {
  var separator = _ref2.separator,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["separator", "children"]);

  var crumbs = null;

  if (children) {
    crumbs = React.Children.map(children, function (child, index) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, {
          current: index === children.length - 1,
          separator: separator
        })
      );
    });
  }

  return (
    /*#__PURE__*/
    React.createElement(Wrapper, rest, crumbs)
  );
};
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.defaultProps = {
  separator: '/'
};